module.exports = __webpack_public_path__ + "static/img/Breem.a864d018.png";